export const configurationConstants = {
  CONFIGURATION_LIST: "ALL_CONFIGURATION_LIST"
};



// WEBPACK FOOTER //
// ./src/_constants/configuration.constants.js